import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1fc1e9f3"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=1fc1e9f3&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.8_babel-core@6.26.3_css-loader@6.11.0_webpack@5.97.1_kggvmkfgk3qwa3dq2eiflp4ibu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports